export const messages = {
  title: 'Sign here',
  confirm: 'Confirm',
  clear: 'Clear',
  cancel: 'Cancel',
} as const
